import { useQuery, useMutation } from "react-query";
import {
  getPMS,
  getReportListByPMS,
  createPMS,
  updatePMS,
  deletePMS,
  addPMSReport,
  updatePMSReport,
  deactivatePMSReport,
  addBulkPMSReport,
} from "../api/pms";

// get all pms
const useGetPMS = (options = {}) => {
  const records = useQuery("getPMSData", getPMS, options);
  return records;
};

const useGetReportListByPMS = (pmsId, options = {}) =>
  useQuery(
    ["getReportsByPMSData", pmsId],
    () => getReportListByPMS(pmsId),
    options,
  );

// add pms report
const useAddPMSReportList = (options = {}) => {
  return useMutation(addPMSReport, options);
};

// create pms
const useCreatePMS = (options = {}) => {
  return useMutation(createPMS, options);
};

// update pms
const useUpdatePMS = (options = {}) => {
  return useMutation(updatePMS, options);
};

// delete pms
const useDeletePMS = (options = {}) => {
  return useMutation(deletePMS, options);
};

// update pms report
const useUpdatePMSReport = (options = {}) => {
  return useMutation(updatePMSReport, options);
};

// deactivate oms report
const useDeactivatePMSReport = (options = {}) => {
  return useMutation(deactivatePMSReport, options);
};

const useBulkCreationPMSReport = (options = {}) => {
  return useMutation(addBulkPMSReport, options);
};


export {
  useGetPMS,
  useGetReportListByPMS,
  useDeletePMS,
  useCreatePMS,
  useUpdatePMS,
  useAddPMSReportList,
  useUpdatePMSReport,
  useDeactivatePMSReport,
  useBulkCreationPMSReport,
};
